export default "__VITE_ASSET__Dtn6fLVT__"